export const reportConstants = {
    GET_ALL_REPORT_SUCCESS: 'app/tenant/GET_ALL_REPORT_SUCCESS',
    GET_ALL_REPORT_FAILURE: 'app/tenant/GET_ALL_REPORT_FAILURE',
};
